import { z } from 'zod';
import type { PartialUndefinedOrNull } from '@/types/partial';
import { TipoPessoa } from '@/types/enum';
import { PessoaCrt, PessoaSexo } from '../enum';
import { type EmailBody, EmailSchema } from './Email';
import { type EnderecoBody, EnderecoSchema } from './Endereco';
import { PessoaFotoSchema } from './PessoaFoto';
import { type TelefoneBody, TelefoneSchema } from './Telefone';

export const PessoaSchema = z.object({
    email: EmailSchema.array().nullable(),
    endereco: EnderecoSchema.array().nullable(),
    pes_cnae: z.string().nullable(),
    pes_cnae_codigo: z.string().nullable(),
    pes_cnae_descricao: z.string().nullable(),
    pes_cnh: z.string().nullable(),
    pes_cnh_validade: z.string().nullable(),
    pes_cnpj_cpf: z.string().nullable(),
    pes_conjuge: z.string().nullable(),
    pes_crt: z.enum(PessoaCrt).nullable(),
    pes_data_nascimento_abertura: z.string().nullable(),
    pes_doc_estrangeiro: z.string().nullable(),
    pes_empresa_idpk: z.number(),
    pes_estado_civil: z.string().nullable(),
    pes_estoque_idpk: z.number().int().nullable(),
    pes_filiacao: z.string().nullable(),
    pes_idpk: z.number(),
    pes_ie_rg: z.string().nullable(),
    pes_im: z.string().nullable(),
    pes_nome_fantasia: z.string().nullable(),
    pes_nome_razaosocial: z.string(),
    pes_observacoes: z.string().nullable(),
    pes_responsavel: z.string().nullable(),
    pes_rg_emissao: z.string().nullable(),
    pes_rg_estado: z.string().nullable(),
    pes_rg_orgao: z.string().nullable(),
    pes_sexo: z.enum(PessoaSexo).nullable(),
    pes_tipo_pessoa: z.enum(TipoPessoa),
    pes_ultima_alteracao: z.string().nullable(),
    pessoa_foto: PessoaFotoSchema.array().nullable(),
    telefone: TelefoneSchema.array().nullable(),
});

export type Pessoa = z.infer<typeof PessoaSchema>;

export type PessoaBody = PartialUndefinedOrNull<Omit<Pessoa, 'email' | 'endereco' | 'telefone'>> & {
    email?: EmailBody[] | null;
    endereco?: EnderecoBody[] | null;
    telefone?: TelefoneBody[] | null;
};
